import React, { Suspense, lazy } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { ChunkLoadErrorBoundary } from "./components/ChunkLoadErrorBoundary";

// Lazy load page components
const Index = lazy(() => import("./views/Index"));
const Login = lazy(() => import("./views/Login"));
const Signup = lazy(() => import("./views/Signup"));
const DocumentPage = lazy(() => import("./views/examples/DocumentPage"));
const ProfilePage = lazy(() => import("./views/examples/ProfilePage"));
const Demo = lazy(() => import("./views/Demo"));
const Gallery = lazy(() => import("./views/examples/Gallery"));
const Chatbot = lazy(() => import("./views/examples/Chatbot"));
const TradePage = lazy(() => import("./views/examples/TradePage"));
const SolopreneurLandingPage = lazy(() => import("./views/examples/ai_apps"));
const AISolutionCanvasPage = lazy(() => import("./components/ai_apps/AISolutionCanvas").then(m => ({ default: m.AISolutionCanvas })));
const ExplorePage = lazy(() => import("./views/examples/ExplorePage"));
const PrivacyPage = lazy(() => import("./views/PrivacyPage"));

function AppRoutes() {
  const location = useLocation();
  return (
    <ChunkLoadErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        {/* 改用更激进的方式强制 remount：key 包含 pathname + search */}
        <Switch key={location.pathname + location.search}>
        <Route exact path="/" render={() => <SolopreneurLandingPage />} />
        <Route exact path="/ai-apps">
          <Redirect to="/" />
        </Route>
        <Route path="/index" render={() => <Index />} />
        <Route path="/login" render={() => <Login />} />
        <Route path="/signup" render={() => <Signup />} />
        <Route path="/profile-page" render={() => <ProfilePage />} />
        <Route path="/profile" render={() => <ProfilePage />} />
        <Route path="/document-page" render={() => <DocumentPage />} />
        <Route path="/documents" exact render={() => <DocumentPage />} />
        <Route path="/documents/:id" render={() => <DocumentPage />} />
        <Route path="/demo" render={() => <Demo />} />
        <Route path="/gallery" render={() => <Gallery />} />
        <Route path="/chatbot" render={() => <Chatbot />} />
        <Route
          path="/trade"
          render={() => (
            <ProtectedRoute>
              <TradePage />
            </ProtectedRoute>
          )}
        />
        <Route exact path="/ai-apps/canvas" render={() => <AISolutionCanvasPage />} />
        <Route path="/ai-apps/:toolId" render={() => <SolopreneurLandingPage />} />
        {/* 确保使用一致的方式渲染组件：统一的 render 或 component */}
        <Route path="/explore" render={() => <ExplorePage />} />
        <Route path="/privacy" render={() => <PrivacyPage />} />
      </Switch>
    </Suspense>
    </ChunkLoadErrorBoundary>
  );
}

function App() {
  return <AppRoutes />;
}

export default App;
